module.exports = __webpack_public_path__ + "static/media/ca_club.040e40ad.png";